import { applyMiddleware, createStore } from "redux";
import thunk from 'redux-thunk';
import { demographicReducer } from "../Reducers/demographicReducer";

const configureStore = () => createStore(demographicReducer,applyMiddleware(thunk));

export default configureStore;